<template>
  <div class="one-column-view">
    <div class="article-content">
      <img
        src="../assets/Goldenlink-comparison.png"
        alt="Traffic Mining Entries"
      />
      <img
        src="../assets/Early-Stage-GSG-Minership.png"
        alt="Early Stages in GSG Entry"
      />
      <p>
        If you're looking to increase this value, consider minting it into
        Traffic & Brand Coins (GSCoin & GLC). This option is available in
        countries that accept crypto coins.
      </p>
      <h1>Mining and Earning Result</h1>
      <p>
        The illustration below show the mining earnings and rewards for GSG
        entry.
      </p>
      <img src="../assets/EarningsAndRewards.png" alt="Earnings And Rewards" />
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style scoped></style>
